import { makeStyles } from '@material-ui/core/styles';

// Constants for reusability and clarity
export const FORM_CONTROL_WIDTH = 200;

const REMOVE_CIRCLE_OUTLINE_SVG = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'/></svg>`;

const REMOVE_CIRCLE_OUTLINE_MASK = `url("data:image/svg+xml,${encodeURIComponent(
  REMOVE_CIRCLE_OUTLINE_SVG
)}")`;

export const useListFilterStyles = makeStyles((theme) => {
  const deleteIconSize = theme.spacing(4);
  return {
    // Main container for filters
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      paddingBottom: theme.spacing(1),
    },
    flexContainer: {
      display: 'flex',
    },
    // Group of filter inputs
    inputsGroup: {
      display: 'flex',
      width: '100%',
      flexWrap: 'wrap',
    },
    // Standard active form control (first row)
    formControl: {
      paddingBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: FORM_CONTROL_WIDTH,
      minWidth: FORM_CONTROL_WIDTH,
      '&:last-child': {
        marginRight: 0,
      },
    },
    formControlRA: {
      paddingBottom: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      width: FORM_CONTROL_WIDTH,
      minWidth: FORM_CONTROL_WIDTH,
      '&:last-child': {
        marginRight: 0,
      },
    },
    // Wider active form control for long inputs (first row)
    formControlLong: {
      width: FORM_CONTROL_WIDTH + deleteIconSize,
    },
    // Removes right margin for added controls to make them the same width
    // as the first row controls
    formControlAdd: {
      marginRight: 0,
    },
    // Extra wide for special cases for added controls
    formControlAddLong: {
      width: FORM_CONTROL_WIDTH * 2 + deleteIconSize + theme.spacing(1),
    },
    // Icon button for deleting filters
    deleteIcon: {
      width: deleteIconSize,
      height: deleteIconSize,
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    hideFilterIcon: {
      '& .hide-filter': {
        order: 1, // RA renders the button before the input; move it after
        position: 'relative',
        color: 'transparent', // hides RA's own HighlightOff glyph
        padding: 4,
        alignSelf: 'center',
        marginRight: theme.spacing(1),
        marginTop: -10,
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 24, // glyph size inside the button, not the button box
          height: 24,
          backgroundColor: theme.palette.action.active,
          WebkitMaskImage: REMOVE_CIRCLE_OUTLINE_MASK,
          maskImage: REMOVE_CIRCLE_OUTLINE_MASK,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
        },
      },
    },
    // Styles for date pickers
    datePickers: {
      marginTop: 0,
      marginBottom: 0,
      '& > div': {
        paddingRight: 0,
        '& > div': {
          marginLeft: 0,
        },
      },
    },
  };
});

export const useDefaultListFilterStyles = makeStyles((theme) => {
  return {
    form: {
      '& > div': {
        '& > div:last-child': {
          width: theme.spacing(1),
        },
      },
    },
    formControl: {
      width: FORM_CONTROL_WIDTH,
    },
    formControlLong: {
      width: FORM_CONTROL_WIDTH * 2 + theme.spacing(1),
    },
  };
});
